<div class="mt-1 mb-3" *ngFor="let groupList of customFieldsGroups; let groupIndex = index;"
    id="i_{{groupIndex}}">
    <ngb-accordion #pageAccordion="ngbAccordion" *ngIf="groupList.group[0]" class="accordion" role="tablist"
        activeIds="static-{{activeIdIndex}}" aria-multiselectable="false" (click)=updateActiveIDIndex(groupIndex)>


        <ngb-panel id="static-{{groupIndex}}" class="accordion-item">

            <ng-template ngbPanelTitle>
                <a class="accordion-header" href="javascript:void(0);">

                    <div class="d-flex position-relative show" style="  z-index: 2;">
                        <h6 class="fs-14 mb-1">
                            {{groupList.groupName}}
                        </h6>
                    </div>
                </a>
            </ng-template>

            <ng-template ngbPanelContent>

                <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div style="margin-top: 1.25rem; margin-bottom: 1.25rem;">
                        <div *ngFor="let subgroups of groupList.subgroups; let subgroupsIndex = index"
                            style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

                            <ngb-accordion *ngIf="subgroups.group[0]" class="accordion" role="tablist"
                                #acc="ngbAccordion" activeIds="static-1" aria-multiselectable="false">
                                <ngb-panel id="static-1" class="accordion-item mb-1">

                                    <ng-template *ngIf="!subgroups.subGroupName" ngbPanelHeader>
                                        <!-- This empty Template controls the default subgroup not having a header in the accordian -->
                                    </ng-template>
                                    <ng-template ngbPanelTitle>
                                        <a data-bs-toggle="collapse" href="javascript:void(0);"
                                            aria-controls="collapseOne">
                                            <div class="d-flex position-relative show" style="  z-index: 3;">

                                                <h6 class="fs-12 mb-1">
                                                    {{subgroups.subGroupName}}
                                                </h6>

                                            </div>
                                        </a>
                                    </ng-template>
                                    <ng-template ngbPanelContent class="show">
                                        <div class="show">
                                            <div aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                <div class="row flex pb-3">
                                                    <div class="col-lg-4 mt-3"
                                                        *ngFor="let data of subgroups.group; let myfileIndex = index">

                                                        <label for="job_type-field" class="form-label"
                                                            style="color: var(--vz-accordion-color)">{{data.caption}}</label>

                                                        <div *ngIf="data.dataType == DataTypeEnum.Date else elseDropdown">
                                                            <div class=" input-group d-flex form-control"
                                                                style="padding: 0%;">
                                                                <input class=" flex-grow-1 form-control"
                                                                    #iValue="ngModel" required style="border-width: 0;"
                                                                    [pattern]=datePattern
                                                                    [disabled]="disableEditing"
                                                                    class="form-control" type="text"
                                                                    [dropSpecialCharacters]="false"
                                                                    [(ngModel)]="data.value" placeholder="DD/MM/YYYY"
                                                                    mask="00/00/0000" i18n-placeholder="@@"
                                                                    (keypress)="basicEdited = true" />
                                                                <span class=" input-group-text ri-calendar-2-line "
                                                                    style="border-width: 0; align-self: center;"
                                                                    [disabled]="disableEditing"
                                                                    type="text" mwlFlatpickr [disableMobile]="true" [(ngModel)]="data.value"
                                                                    [dateFormat]="'d/m/Y'"></span>
                                                            </div>
                                                        </div>

                                                        <ng-template #elseDropdown>
                                                            <div *ngIf="data.dataType == DataTypeEnum.DropDown else elseBool">
                                                                <app-ng-select-layout [placeHolderText]="'Select Value'"
                                                                    [disableInput]="disableEditing"
                                                                    [(model)]="data.value"
                                                                    [items]="data.keyValues"></app-ng-select-layout>
                                                            </div>

                                                        </ng-template>
                                                        <ng-template #elseBool>
                                                            <div *ngIf="data.dataType == DataTypeEnum.Boolean else elseBasicInput">

                                                                <div class="form-check form-switch">
                                                                    <input
                                                                        [disabled]="disableEditing"
                                                                        class="form-check-input" type="checkbox"
                                                                        [checked]="getCheckboxBoolValue(data.value)"
                                                                        (change)="setCheckboxBoolValue(data.value,groupIndex,subgroupsIndex,myfileIndex)" />
                                                                </div>

                                                            </div>
                                                        </ng-template>
                                                        <ng-template #elseBasicInput>
                                                            <input
                                                                [disabled]="disableEditing"
                                                                class="form-control" type="text"
                                                                placeholder="Enter {{data.caption}}"
                                                                i18n-placeholder="@@" [(ngModel)]="data.value"
                                                                (keypress)="basicEdited = true" />
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </ngb-panel>
                            </ngb-accordion>
                        </div>
                    </div>
                </div>

            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</div>